import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import {
  API_URL,
  IAuthorizedUserDto,
  IAuthorizedUserDtoRelationshipTypeEnum,
  IAuthorizedUserDtoStatusEnum,
  IPage,
} from '@/dtos';

import { AuthorizedUser } from '../authorizedUsers.types';

const useGetAuthorizedUsersListQuery = (employeeId?: string) => {
  const { data, isLoading } = useQuery(
    [API_URL.EMPLOYEES_AUTHORIZED_USERS_BY_EMPLOYEE_ID(''), employeeId],
    () => api.get<IPage>(API_URL.EMPLOYEES_AUTHORIZED_USERS_BY_EMPLOYEE_ID(employeeId || '')),
    {
      enabled: !!employeeId,
    }
  );

  const formattedData = useMemo<AuthorizedUser[]>(
    () =>
      ((data?.data?.content ?? []) as IAuthorizedUserDto[]).map((item) => ({
        id: `${item.id}`,
        firstName: item.first_name || '',
        lastName: item.last_name || '',
        relationshipType: item.relationship_type as IAuthorizedUserDtoRelationshipTypeEnum,
        birthOn: `${item.birth_on || ''}`,
        createdAt: `${item.created_at || ''}`,
        status: item.status as IAuthorizedUserDtoStatusEnum,
      })),
    [data]
  );

  return { authorizedUsers: formattedData, isLoading };
};

export default useGetAuthorizedUsersListQuery;
